module.exports = __webpack_public_path__ + "img/orange.2baba113.png";